import moment from 'moment-timezone'
import { isNil } from 'lodash'

export const utcOffset = (dateString) => {
    let date = moment.tz(dateString, moment.tz.guess())

    return moment.utc(date)
}

export const utcToLocal = (dateString, fromFormat = 'YYYY-MM-DD HH:mm:ss') => {
    if (isNil(dateString))
        return null

    let utcOffset = window.localStorage.getItem('utcOffset') || 'Etc/GMT'

    return moment.utc(dateString, fromFormat).tz(utcOffset)
}



// WEBPACK FOOTER //
// ./src/utils/helpers/dates.js